/* URL curat pentru ancore: scoate #hash din bara de adresă după derulare */
(function(){
  var MAP = { 'despre-noi': '/despre-noi' };
  function clean(){
    var h = window.location.hash.replace('#','');
    if(!h || !MAP[h]) return;
    var el = document.getElementById(h);
    if(!el) return;
    setTimeout(function(){
      el.scrollIntoView({behavior:'smooth', block:'start'});
      try{ history.replaceState(null,'',MAP[h]); }catch(e){}
    }, 60);
  }
  if(document.readyState !== 'loading') clean();
  else document.addEventListener('DOMContentLoaded', clean);
  document.addEventListener('click', function(e){
    var a = e.target.closest ? e.target.closest('a[href*="#despre-noi"], a[href$="/despre-noi"]') : null;
    if(!a) return;
    var el = document.getElementById('despre-noi');
    if(!el) return;
    e.preventDefault();
    el.scrollIntoView({behavior:'smooth', block:'start'});
    try{ history.replaceState(null,'','/despre-noi'); }catch(err){}
  });
})();